import { render, staticRenderFns } from "./ProjectsListAll.vue?vue&type=template&id=4a20b543&scoped=true"
import script from "./ProjectsListAll.vue?vue&type=script&lang=js"
export * from "./ProjectsListAll.vue?vue&type=script&lang=js"
import style0 from "./ProjectsListAll.vue?vue&type=style&index=0&id=4a20b543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20b543",
  null
  
)

export default component.exports